import {
  Box,
  Flex, FormControl, FormLabel, Select, Switch, Text, VStack,
} from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { get } from '@submize/lodash';
import { useLocation } from 'react-router-dom';
import ColorPicker from '../../ColorPicker/ColorPicker';
import {
  getForm, setBgColor, setBorderColor, setColor, setContainerSize, setShadow, setSize,
  setTextColor,
} from '../formSlice';
import { buildPalette } from '../../../helpers';
import ContainerSizeField from './ContainerSizeField';
import AdvanvedSettings from './AdvancedSettings';
import SelectTemplate from '../SelectTemplate';
import SaveAsTemplate from '../SaveAsTemplate';

const options = [
  { key: 'xs', value: 'xs' },
  { key: 'sm', value: 'sm' },
  { key: 'md', value: 'md' },
  { key: 'lg', value: 'lg' },
];
const DesignSideBar = () => {
  const { design } = useSelector(getForm);
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const onChangeButtonColor = (value) => {
    dispatch(setColor(buildPalette(value)));
  };
  const onChangeBgColor = (value) => {
    dispatch(setBgColor(value));
  };
  return (
    <Box color="gray.600" p="0">
      {pathname.startsWith('/form') && <SelectTemplate />}
      <Text w="100%" as="h3" fontWeight="bold" fontSize="md" mb="3">Setup theme</Text>
      <VStack fontSize="sm" gap="3" overflowY="scroll" height="calc(100vh - 260px)" pr="3" mr="-3" pb="3">
        <Text w="100%" as="h4" fontWeight="bold" fontSize="sm">Container</Text>
        <ContainerSizeField size={get(design, 'containerSize.size', 'md')} onChange={(v) => dispatch(setContainerSize(v))} />
        <Flex justify="space-between" w="100%">
          <Text>Background color</Text>
          <ColorPicker color={get(design, 'backgroundColor')} onChange={onChangeBgColor} />
        </Flex>
        <FormControl display="flex" justifyContent="space-between" w="100%">
          <FormLabel fontSize="sm" mb="0">Shadow</FormLabel>
          <Switch isChecked={get(design, 'shadow')} onChange={(e) => dispatch(setShadow(e.target.checked))} />
        </FormControl>

        <Text w="100%" as="h4" fontWeight="bold" fontSize="sm" mt="3">Fields</Text>
        <FormControl>
          <FormLabel fontSize="sm" mb="1">Field size</FormLabel>
          <Select value={get(design, 'size', 'sm')} onChange={(e) => dispatch(setSize(e.target.value))}>
            {options.map(({ key, value }) => <option key={key} value={key}>{value}</option>)}
          </Select>
        </FormControl>
        <Flex justify="space-between" w="100%">
          <Text>Main color</Text>
          <ColorPicker color={get(design, 'colors.submize.500')} onChange={onChangeButtonColor} />
        </Flex>
        <Flex justify="space-between" w="100%">
          <Text>Border color</Text>
          <ColorPicker color={get(design, 'borderColor')} onChange={(v) => dispatch(setBorderColor(v))} />
        </Flex>
        <Flex justify="space-between" w="100%">
          <Text>Text color</Text>
          <ColorPicker color={get(design, 'textColor')} onChange={(v) => dispatch(setTextColor(v))} />
        </Flex>
        {/* <HStack gap={0} mt="40">
        <Box bg={get(design, 'colors.submize.50')} w="25px" h="15px" />
        <Box bg={get(design, 'colors.submize.100')} w="25px" h="15px" />
        <Box bg={get(design, 'colors.submize.200')} w="25px" h="15px" />
        <Box bg={get(design, 'colors.submize.300')} w="25px" h="15px" />
        <Box bg={get(design, 'colors.submize.400')} w="25px" h="15px" />
        <Box bg={get(design, 'colors.submize.500')} w="25px" h="15px" />
        <Box bg={get(design, 'colors.submize.600')} w="25px" h="15px" />
        <Box bg={get(design, 'colors.submize.700')} w="25px" h="15px" />
        <Box bg={get(design, 'colors.submize.800')} w="25px" h="15px" />
        <Box bg={get(design, 'colors.submize.900')} w="25px" h="15px" />
      </HStack> */}
        <AdvanvedSettings design={design} />
      </VStack>
      {pathname.startsWith('/form') && <SaveAsTemplate />}
    </Box>
  );
};

export default DesignSideBar;
